// extracted by mini-css-extract-plugin
export default {"formattedDate":"_73z7kjOIH1Io5wEfu8uJLg=="};